import { useSyncExternalStore } from 'react'
import { HealthState } from '../../../types/state'
import { pubSubHealth } from '../../state/pubSub'
import { getHealthState } from '../../state/state.health'

const subHealthState = (callback) => pubSubHealth.on('state', callback)
const getHealthStateSelector =
    <T extends keyof HealthState>(key: T) =>
    () => {
        // console.log('[getHealthStateSelector]', getHealthState())
        return getHealthState()[key]
    }

export const useHealthAppState = (): HealthState => {
    return useSyncExternalStore(subHealthState, getHealthState, getHealthState)
}

export const useHealthAppStateSelector = <T extends keyof HealthState>(
    key: T,
): HealthState[T] => {
    return useSyncExternalStore(
        subHealthState,
        getHealthStateSelector(key),
        getHealthStateSelector(key),
    )
}
